import React, {Component} from 'react'
import { Table, notification, Tabs} from "antd";
import {
    myReviewGridData,
    myReviewMtyy,
     postPublic,
} from "../../../../actions";
import {applicationName, formatDate} from '../../../../utils'
import {connect} from "react-redux";
import {HEADER_HEIGHT} from "../../../../constants";
import {Scrollbars} from "react-custom-scrollbars";
import $ from 'jquery'
const { TabPane } = Tabs;
//不要随便删除下面   global layer * 这个代码
/* global layer */
class MediaAppointNeedTodoComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            myMtyydatas: [],
            mttyCount:0,
            height:window.innerHeight-100,
            myAuditloading: false,

        }
    }
    updatemyReviewMtyy(myReviewMtyy) {
        this.setState({
            myMtyydatas: myReviewMtyy,
            myMtyyloading: true,
            getMtyytime: 1,
            mttyCount: myReviewMtyy.length
        })
    }
    updateMyReviewGrid(myAuditdata) {
        let that = this;
        if(this.state.getMtyytime==0) {
            setTimeout(function () {
                that.updateMyReviewGrid(myAuditdata);
            },300)
        }else{
            var ss = myAuditdata.data;
            for(let i =0;i<this.state.myMtyydatas.length;i++){
                ss.unshift(this.state.myMtyydatas[i]);
            }

            this.setState({
                myAuditdatas: ss,
                myAuditloading: true,
                mttyCount: this.state.myMtyydatas.length,
                needTodoCount: ss.length,
            })
        }
    }

    updateMyMessageGrid(myMessageData) {

        this.setState({
            myMessageData: myMessageData.data,
            myMessageloading: true,

        })
    }

    componentDidMount() {
        window.addEventListener('resize', this.resize.bind(this));
        this.lastLoginLog();
        let that = this;
        var timeUpdate=setInterval(function () {
            if(that.props.currentUser){
                clearInterval(timeUpdate)
                let param = that.props.currentUser;
                myReviewMtyy(param, that.updatemyReviewMtyy.bind(that));
            }

        },400)
    }


    resize(){
        this.setState({
            height: document.body.clientHeight - HEADER_HEIGHT
        })
    }

    componentWillUnmount() {
        window.removeEventListener('resize',this.resize);
    }

    //查看按钮，不同的流程，不同的媒体弹不同的框
    chekcData(record) {
        let obj = record.object;
        if(obj.type === "internalArrange"){
            this.viewInterArrange(record)
        }else if(obj.type === "externalArrange"){
            this.viewExterArrange(record);
        }else if (record.actButton.deploymentkey.indexOf( "story") == 0 || record.actButton.deploymentkey.indexOf("yuegao") == 0) {
            if(obj.storyType === "PIC"){
                this.pics(record);
            }else if (obj.mediaCode || record.actButton.deploymentkey.indexOf( "story") == 0) {
                this.websiteViewStory(record);
            } else { //投稿端
                this.viewStory(record);
            }

        }else if (record.actButton.deploymentkey.indexOf( "fzr") == 0  || record.actButton.deploymentkey.indexOf( "unfzr") == 0) {
            this.showInterview(record);
        } else if (record.actButton.deploymentkey.indexOf( "weixin") == 0) {
            this.weixinViewMaterial(record);
        } else if (record.actButton.deploymentkey.indexOf( "weibo") == 0 ) {
            this.websiteViewWeibo(record);
        } else if(record.actButton.deploymentkey.indexOf( "urlstory") == 0){
            this.showUrlStory(record);
        }

    }

    /**
     * 稿件的查看  （管理端）
     * @param record
     */
    websiteViewStory(record) {
        let that = this;
        window.openFull("/cm-sites/pms/addContribute/addContributeNews.html?eiditStoryId=" + record.object._serviceId+"&processInstanceId="+record.object._ProcessInstanceId
            +"&currentMediaCode=" + record.object.mediaCode + "&actButtonId="+record.actButton.id,record.title,null,null,null,function(){
            myReviewGridData(that.props.currentUser, that.updateMyReviewGrid.bind(that));
        });
    }

    pics(record){
        let url = "/cm-sites/pms/addContribute/atlasdetail.html?currentStoryId="+ record.object.id +"&currentMediaCode=" + record.object.mediaCode +"&treeId="+ record.object.treeId + "&treeContentId=" + record.object.treeContentId;
        window.openFull(url, "编辑组图", null, {
            shade: 0.5,
            area: [parseInt(window.document.body.clientWidth * 0.6) + 'px',parseInt(window.document.body.clientHeight * 0.8) + 'px']
        })
    }

    /**
     * 查看校内预约（管理端）
     * @param record
     */
    viewInterArrange(record){
        let url = "/cm-sites/pms/mediaReservation/internal/internalClueView.html?id="+ record.object.id;
        window.openFull(url, "预约详情", null, {
            shade: 0.5,
            btn: ['采用', '拒绝'],
            area: [parseInt(window.document.body.clientWidth * 0.6) + 'px',parseInt(window.document.body.clientHeight * 0.6) + 'px'],
            yes : function(index, layero) {
                var openPage = window[layero.find('iframe')[0]['name']];
                openPage.changeAppointment(record.object.id);
            },
            btn2: function (index, layero) {
                var openPage = window[layero.find('iframe')[0]['name']];
                openPage.decideUse(record.object.id);
                return false;
            },
            success: function(){
                $('.layui-layer-btn1').css('background-color','rgb(255, 87, 34)');
                $('.layui-layer-btn1').css('color','rgb(255, 255, 255)');
                $('.layui-layer-btn1').css('border-color','rgb(255, 255, 255)');
            },
        })
    }

    /**
     * 查看校外预约 （管理端）
     * @param record
     */
    viewExterArrange(record){
        let url = "/cm-sites/pms/mediaReservation/external/externalClueView.html?id="+ record.object.id;
        window.openFull(url, "预约详情", null, {
            shade: 0.5,
            btn: ['采用', '拒绝'],
            area: [parseInt(window.document.body.clientWidth * 0.6) + 'px',parseInt(window.document.body.clientHeight * 0.8) + 'px'],
            yes : function(index, layero) {
                var openPage = window[layero.find('iframe')[0]['name']];
                openPage.decideUse(true,record.object.id);
            },
            success: function(){
                $('.layui-layer-btn1').css('background-color','rgb(255, 87, 34)');
                $('.layui-layer-btn1').css('color','rgb(255, 255, 255)');
                $('.layui-layer-btn1').css('border-color','rgb(255, 255, 255)');
            },
            btn2: function (index, layero) {
                var openPage = window[layero.find('iframe')[0]['name']];
                openPage.decideUse(false,record.object.id);
                return false;
            }
        })
    }

    /**
     * 稿件的查看 （投稿端）
     * @param record
     */
    viewStory(record) {
        let that = this;
        var data = record;
        var object = data.object;

        window.openFull("/cm-sites/pms/writing/writingNew.html?eiditStoryId=" + object._serviceId
            + "&processInstanceId=" + object._ProcessInstanceId + "&actButtonId=2",record.title,null,null,null,function() {
            myReviewGridData(that.props.currentUser, that.updateMyReviewGrid.bind(that));
        });
    }

    /**
     *稿件的查看  unfzr 的查看
     * @param record
     */
    showInterview(record){
        let that = this;
        let interviewId= record.object.interviewId;
        // window.location.hash = '#/interviewTask/interviewTaskdetail/'+interviewId;
        window.openFull("/cm-sites/pms/interviewTask/interviewTaskdetail.html?interviewId="+interviewId,record.title,null,null,null,function() {
            myReviewGridData(that.props.currentUser, that.updateMyReviewGrid.bind(that));
        });
    }

    /**
     * 微信的查看功能
     */
    weixinViewMaterial(record){
        let that = this;
        let data = record;
        let object = data.object;
        let url = "/cm-sites/pms/wechat/editMaterial.html?materialId=" +object._serviceId + "&currentMedia=" + object.mediaCode + "&actButtonId=7";
        if(object._ProcessInstanceId){
            url += "&processInstanceId="+object._ProcessInstanceId;
        }else {
            url += "&processInstanceId=0";
        }
        window.openFull(url,"微信",null,null,null,function() {
            myReviewGridData(that.props.currentUser, that.updateMyReviewGrid.bind(that));
        });
    }

    /**
     * 链接稿件的查看功能
     */
    showUrlStory(record){
        let that = this;
        let data = record;
        let object = data.object;
        let title = "";
        if(object.storyType.indexOf("WEIBO") ){
            title = "微博链接稿件";
        }else if(object.storyType.indexOf("WEIBO") ){
            title = "微信链接稿件";
        }
        let url = "/cm-sites/pms/wechat/wechatAdd.html?id=" + object._serviceId + "&actButtonId=8&fromHome=home";
        if(object._ProcessInstanceId){
            url += "&processInstanceId="+object._ProcessInstanceId;
        }else {
            url += "&processInstanceId=0";
        }
        window.openSmall(url,title,null,null,null,function() {
            myReviewGridData(that.props.currentUser, that.updateMyReviewGrid.bind(that));
        });
    }

    lastLoginLog(){
        let that = this;
        let newLogin = window.getCookie("newLogin");
        if(newLogin === true || newLogin === 'true'){
            postPublic("/cm-sites-" + applicationName() + "/getLastLoginLog",null,function(res){
                window.delCookie("newLogin","/",window.location.host);
                if(res){
                    let description = <div>
                        <span>上次登陆时间：{window.formatDate(res.loginTime)}</span>
                        <span>上次登陆ip：{res.ip}</span>
                    </div>;
                    that.openNotification(description);
                }
            } )
        }
    }

    openNotification(description){
        notification.info({
            message: '上次登陆时间',
            description: description,
            placement: 'bottomRight'
        });
    }
    /**
     * 微博查看功能
     * @param record
     */
    websiteViewWeibo(record){
        let weibo = record;
        let content = "/cm-sites/pms/weibo/write.html?actButtonId=3&weiboId="+weibo.object.id+"&currentMedia="+weibo.object.mediaCode +"&processInstanceId="+weibo.processInstanceId;
        let that = this;
        layer.open({
            btn: null,
            type: 2,
            content: content,
            title : "查看微博",
            resize : true,
            maxmin: true,
            //shade : 0.001,	//遮罩
            shade : 0.7,
            shadeClose : true,	//点击遮罩是否关闭
            zIndex : 100,
            area : ['800px', '560px'],
            yes : function(index, layero) {
            }
            ,cancel: function(index, layero){
                layer.close(index);
            },end: function(){
                myReviewGridData(that.props.currentUser, that.updateMyReviewGrid.bind(that));
            }
        })

    }

    /**
     * 获取标题
     * @param recorde
     */
    getTitle(recorde) {
        let title = "";
        let li;
        if(recorde.type){
            title = recorde.object.title;
            li=<i className='icon icon-pc'></i>
        }else {
            let obj = recorde.object;

            if (recorde.actButton.deploymentkey.indexOf("story") === 0 || recorde.actButton.deploymentkey === "yuegao"
                || recorde.actButton.deploymentkey === "fzr" || recorde.actButton.deploymentkey === "unfzr") {
                title = obj.title;
                li = <i className='icon icon-pc'></i>
            } else if (recorde.actButton.deploymentkey === "weixin") {
                title = obj.stuffList[0].title;
                li = <i className='icon icon-wechat'></i>
            } else if (recorde.actButton.deploymentkey === "weibo") {
                title = obj.content;
                li = <i className='icon icon-wb'></i>
            } else if (recorde.actButton.deploymentkey === "urlstory") {
                title = obj.title;
                li = <i className='icon icon-wb'></i>
            }
        }
        return <span className={""} style={{cursor:"pointer"}} title={title}>{li}{title}</span>
    }

    /**
     * 获取作者信息
     * @param recorde
     */
    getUserName(recorde) {
        let obj = recorde.object;
        let author = obj._userName;
        return author;
    }

    /**
     * 获取待审类型
     * @param recorde
     */
    getType(recorde) {
        var type ="稿件";
        let obj = recorde.object;
        if(obj.type === "internalArrange"){
            type ="校内预约";
        }else if(obj.type === "externalArrange"){
            type ="校外预约";
        }
        return type;
    }

    /**
     *获取提交时间
     * @param recorde
     */
    getCreateDate(recorde) {
        let obj = recorde.object;
        let _updateDate = obj._updateDate;
        if((typeof _updateDate) =="string"){
            _updateDate = parseFloat(_updateDate);
        }
        let submitDate = formatDate(_updateDate);
        return submitDate
    }

    changeTab(tabIndex){
      console.info('changeTab',tabIndex);
    }


    loadDialogIndex = null;
    render() {
        this.state.myMtyydatas.forEach((item,i)=>{
            item.key=i;
        });
        const myAuditcolumns = [{
            title: '标题',
            dataIndex: 'object.content',
            key: 'object.content',
            width: '60%',
            ellipsis:true,
            render: (text, record) => {
                return <span style={{cusor:'pointer'}} onClick={() => this.chekcData(record)}>{this.getTitle(record)}</span>
            }
        },
            {
                title: '提交人',
                dataIndex: '_userName',
                key: '_userName',
                width: '15%',
                align: 'center',
                ellipsis:true,
                render: (text, record) => {
                    return this.getUserName(record)
                }
            },
            {
                title: '类型',
                dataIndex: 'type',
                key: 'type',
                width: '15%',
                align: 'center',
                ellipsis:true,
                render: (text, record) => {
                    return this.getType(record)
                }
            },
            {
                title: '提交时间',
                dataIndex: 'createTime',
                key: 'createTime',
                width: '15%',
                align: 'center',
                ellipsis:true,
                render: (text, record) => {
                    return this.getCreateDate(record)
                }

            }, {
                title: '操作',
                dataIndex: 'operate',
                key: '操作',
                width: '10%',
                align: 'center',
                ellipsis:true,
                render: (text, record) =>
                    <a style={{cusor:'pointer'}} onClick={() => this.chekcData(record)}><u>查看</u></a>,

            }];
        return (
            <div className={'StaticMyDeskItemPaddingTop'}>
                <div style={{background: '#FFFFFF', position: 'relative'}}>
                    <div style={{
                        height: 56,
                        lineHeight: '56px',
                        background: 'white',
                        width: '100%',
                        float: 'left',
                    }}>
                        <Tabs defaultActiveKey="1" onChange={(key) => {
                            this.changeTab(key)
                        }}>
                            <TabPane tab={"媒体预约" + "(" + this.state.mttyCount + ")"} key="1"/>
                        </Tabs>
                    </div>
                    <div style={{clear: 'both'}}/>
                    <div style={{height:360}}>
                        <Scrollbars>
                            <Table style={{marginTop: 10}} locale={{emptyText: '暂无数据'}} size={'small'} rowKey={'id'}
                                   pagination={false} onRow={record => {
                                return {
                                    onClick: event => {
                                        // this.checkMyMessage(record)
                                    }, // 点击行
                                    onDoubleClick: event => {
                                    },
                                    onContextMenu: event => {
                                    },
                                    onMouseEnter: event => {
                                    }, // 鼠标移入行
                                    onMouseLeave: event => {
                                    },
                                };
                            }} dataSource={this.state.myMtyydatas}
                                   columns={myAuditcolumns}/>
                        </Scrollbars>
                    </div>
                    </div>
                </div>
        )
    }

}
function mapStateToProps(state){
    return {
        currentUser: state.systemReducer.currentUser,
    }
}
export default connect(mapStateToProps)(MediaAppointNeedTodoComponent);